import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/lazy";
import SwiperCore, {  Lazy, Pagination, Navigation} from 'swiper';


SwiperCore.use([Lazy, Pagination, Navigation]);

import "./CarouselAboutUs.css";


const CarouselAboutUs= (props)=>{
    let params = {
        dir: "ltr",
        modules: [Pagination, Navigation, Lazy],
      // modules: [Pagination, Navigation],
        preloadImages: false,
        observer: true,
        lazy: true,
        loop: true,
        grabCursor: true,
        keyboard: {
          "enabled": true
        },
        pagination: {
          "clickable": true,
          "renderBullet": function (index, className) {
            return '<span class=\"modBullet ' + className + '\"></span>';
          }
        },
        navigation: true,
        style: { '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#B69863' },
        spaceBetween: 20,
        speed: 50,
        slidesPerView: 1,
        //slidesToShow: 1,
        initialSlide: 1,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 300,
          }
        },
    
      };
    const [activetionControll,setActivetionControll] = useState([]);
    const [visibleElements,setVisibleElements] = useState(1);
    const [isMobile, setIsMobile] = useState(true);
    useEffect(()=>{
        if(window.innerWidth > 768){
            setIsMobile(false);
        }
        if(props.items.length>0){

            let tempArray = new Array(props.items.length).fill(true);
            tempArray.fill(false,visibleElements);
            setActivetionControll(tempArray);
        }
    },[props.items]);
   
    const ChangeActivtion=(e)=>{
        if(e.target.className.indexOf('prev')>-1){
            //take prev
        
            let tempArray =[...activetionControll];
            const firstFalseIdx = tempArray.indexOf(false);

            tempArray[firstFalseIdx]=true;
            tempArray[firstFalseIdx+visibleElements]=false;
            setActivetionControll(tempArray);
            
        }
        else{
       
            let tempArray =[...activetionControll];
            const firstFalseIdx = tempArray.indexOf(false);

            tempArray[firstFalseIdx]=true;
            tempArray[firstFalseIdx-visibleElements]=false;
            setActivetionControll(tempArray);
            //take next
        }
    }
    
    return (
        <>
        <Swiper {...params}>
          <div className='custom-aboutus-swiper-warpper col-12'> 
          {props.items.map(
            (item, idx) =>
              (
                <SwiperSlide key={`slide_${idx}`} className='col-12'>
                    <div key={idx} className={'col-12  carousel-item'}>
                     <div className='col-12 p-d-md-none carousel-aboutus-title'>{item.ContainerTitle}</div> 
                        
      <div className='col-12 col-md-6 carousel-aboutus-background-div'
       style={{backgroundImage: !!item.MashanTopDesktopImage.ImageUrl ? `url(${item.MashanTopDesktopImage.ImageUrl+ (isMobile? '?RenditionID=13':'?RenditionID=12')})`:''}}>
                        </div>
                        <div className='col-11 col-md-5 carousel-content'>
                            <div className='col-12 p-d-none p-d-md-block carousel-aboutus-title'>{item.ContainerTitle}</div>
                            <div className='col-12 carousel-aboutus-rich-text' dangerouslySetInnerHTML={{__html:item.RichTextContainer}}></div>
                        </div>
                    </div>
                   
                </SwiperSlide>
              )
          )}
          </div>
        </Swiper>
      </>
        
    )
}



export default CarouselAboutUs;